import { client } from "@/apis/client";
import { useQuery } from "@tanstack/react-query";

// TODO: 백엔드에서 보내주는 타입과 실제로 받는 값이 다른 거 같음 확인 필요
const useJobStatusQuery = ({
  page = 1,
  perPage = 15,
  enabled = true,
  isRefetching = true,
}) => {
  return useQuery({
    queryKey: ["job-status", page, perPage],
    queryFn: () => {
      return client.GET("/api/v2/jobplan", {
        params: {
          query: {
            page,
            itemsPerPage: perPage,
            sortBy: "id",
            sortDesc: "true",
          },
        },
      });
    },
    refetchInterval: isRefetching ? 2000 : undefined,
    select: (data) => data?.data?.data,
    enabled,
  });
};

export default useJobStatusQuery;
